import styled from 'styled-components';


export const ItemWrapper = styled.div<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid #dfdfdf;
  opacity: ${({ isActive }) => (!isActive ? 1 : 0.5)};
  gap: 16px;
`;

export const Title = styled.h3`
  grid-area: title;
  font-weight: 500;
  line-height: 1.2;
`;

export const AuthorContent = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AuthorInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const EmailWrapper = styled.div`
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 16px;
`;

